import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getCssVariable } from "src/utils/utils";
import { client } from "src/utils/api";
import Layout from "src/pages/Layout/Layout";
import { Testimonial } from "src/pages/Products/components";
import { MarqueeComponent } from "src/pages/Home/components";
import PartnerImageAndList from "src/pages/Partnership/components/PartnerImageAndList";
import { useAppContext } from "src/components/contextAPI/AppContext";
import SiteScoreHeader from "../SiteScore/components/SitecoreHeader";
import PartnerCard from "../Partnership/components/PartnerCard";
import EnterpriseColumn2List  from "src/pages/Enterprise/components/EnterpriseColumn2List";
import SharedVision from "../SiteScore/components/SharedVision";
const TaskInitiation = () => {
  const gqlClient = client;
  const navigate = useNavigate()
  const primaryColor = getCssVariable("--primary-color");
  const [productPageData, setProductPageData] = useState<any[]>([]);
  const [seoData, setSeoData] = useState<any>();
  const [loading, setLoading] = useState(true);
  const location = useLocation();
  const pathParts = location.pathname.toLowerCase().split("/").filter(Boolean);
  const isBaseRoute = pathParts.length === 1 && pathParts[0] === "task-initiation";
  const slug = isBaseRoute ? "task-initiation" : pathParts[1];

  // Add context hook
  const { updateData } = useAppContext();

  useEffect(() => {
    const fetchProductPageData = async () => {
      try {
        setLoading(true);

        const productResponse = await gqlClient.GetPageBatchBySlug({
          slug: "task-initiation",
        });

        const productId =
          productResponse?.pageGenericCollection?.items[0]?.sys.id;

        if (!productId) {
          navigate('/not-found', { replace: true });
          return;
        }
        const [responseOne, responseTwo, responseThree] = await Promise.all([
          gqlClient.GetTaskInitiationtOne({ id: productId }),
          gqlClient.GetTaskInitiationtTwo({ id: productId }),
          gqlClient.GetTaskInitiationtThree({ id: productId, infoLimit: 3 }),

        ]);

        const componentsOne =
          responseOne?.pageGeneric?.componentsCollection?.items || [];
        const componentsTwo =
          responseTwo?.pageGeneric?.componentsCollection?.items || [];
        const componentsThree =
          responseThree?.pageGeneric?.componentsCollection?.items || [];
        const cleanedData = [...componentsOne, ...componentsTwo, ...componentsThree].filter(
          (item) => item && item.sys?.id && Object.keys(item).length > 2
        );

        setProductPageData(cleanedData);

        setLoading(false);
      } catch (error) {
        console.error("Error fetching Product data:", error);
        setLoading(false);
      }
    };

    fetchProductPageData();
  }, [slug]);


  useEffect(() => {
    if (productPageData) {
      const seoComponent =
        productPageData?.find(
          (item: any) => item.__typename === "SeoFields"
        );
      if (seoComponent) setSeoData(seoComponent);
    }
  }, [productPageData])

  // New useEffect to send contact data to context
  useEffect(() => {
    if (productPageData && productPageData.length > 0) {
      const contact = productPageData.filter(
        comp => comp.__typename === "ImageAndText" && comp.variant == null
      );

      // Get the first contact item (assuming there's only one)
      const contactData = contact[0];

      if (contactData) {
        const contextData = {
          title: contactData.title || "",
          buttonLink: {
            buttonImage: contactData.buttonLink?.buttonImage || null,
            buttonLink: contactData.buttonLink?.buttonLink || null,
            buttonText: contactData.buttonLink?.buttonText || "Meet with Gradial",
            buttonType: contactData.buttonLink?.buttonType || null
          }
        };

        updateData(contextData);

      }
    }
  }, [productPageData]);

  
console.log("productPageData" ,productPageData);

  
  const renderComponent = (component: any) => {
    const componentMap = {
      ImageAndText: {
        TextAndImage:(props) => <SiteScoreHeader {...props} className="batch-banner" batch={true} />,
        TextOnly: SharedVision,
      },
      CardList: {
        "1Column":(props) => <EnterpriseColumn2List {...props} className="batch-features" />,
      },
      LogoList: {
        LogoList: (props) => <div className="batch-marquee"><MarqueeComponent {...props} batch={true}/> </div>,
      },
      ImageAndTextList: (props) => <div><PartnerImageAndList {...props} className="batch-partner-showcase" /> </div>,
      Accordion: {
        'Card': (props) => <PartnerCard {...props} className="works-card" />,
        'Accordion': (props) => <PartnerCard {...props} className="workload-card task-workload-card" />,
      },
    };

    const contentTypeId = component.__typename;
    const variant = component.variant;

    // Handle components with variants
    if (
      contentTypeId === "ImageAndText" ||
      contentTypeId === "Accordion" ||
      contentTypeId === "CardList" ||
      contentTypeId === "LogoList"
    ) {
      const Component = componentMap[contentTypeId]?.[variant];
      if (Component) {
        return <Component key={component.sys.id} content={component} />;
      }
      console.warn(
        `Unmapped variant: ${variant} for contentTypeId: ${contentTypeId}`
      );
      return null;
    } else {
      // Handle all other components
      const Component = componentMap[contentTypeId];
      if (Component) {
        return <Component key={component.sys.id} content={component} />;
      }
      console.warn(`Unmapped component: ${contentTypeId}`);
      return null;
    }
  };


  // This function reorganizes components in the desired order
  const getReorderedComponents = () => {
    if (!productPageData || productPageData.length === 0) return [];
    const contact: any = productPageData.filter(
      comp => comp.__typename === "ImageAndText" && comp.variant == null
    );

    const imageAndText = productPageData.filter(
      comp => comp.__typename === "ImageAndText" && comp.variant == "TextAndImage"
    );

    const tabList = productPageData.filter(
      comp => comp.__typename === "TabList"
    );

    const TextOnly = productPageData.filter(
      comp => comp.__typename === "ImageAndText" && comp.variant == "TextOnly"
    );

    const cardList2Column = productPageData.filter(
      comp => comp.__typename === "CardList" && comp.variant === "1Column"
    );

    const accordionCard = productPageData.filter(
      comp => comp.__typename === "Accordion" && comp.variant === "Card"
    );

    const accordionAccordion = productPageData.filter(
      comp => comp.__typename === "Accordion" && comp.variant === "Accordion"
    );

    const logoList = productPageData.filter(
      comp => comp.__typename === "LogoList"
    );

    const imageAndTextList = productPageData.filter(
      comp => comp.__typename === "ImageAndTextList"
    );

    // Other components that don't match the specific criteria above
    const otherComponents = productPageData.filter(
      comp =>
        !(comp.__typename === "ImageAndText") &&
        !(comp.__typename === "TabList") &&
        !(comp.__typename === "TextOnly") &&
        !(comp.__typename === "CardList") &&
        !(comp.__typename === "Accordion") &&
        !(comp.__typename === "LogoList") &&
        !(comp.__typename === "ImageAndTextList")
    );

    // Return components in the desired order:
    // 1. TextAndImage
    // 2. TabList
    // 3. TextOnly
    // 4. CardList (both variants)
    // 5. LogoList
    // 6. ImageAndTextList
    return [
      ...imageAndText,          // TextAndImage
      ...TextOnly,              // TextOnly
      ...accordionCard,
      ...cardList2Column,       // CardList (2Column)
      ...accordionAccordion,           // TextOnly
     
      ...imageAndTextList,      // ImageAndTextList
      ...tabList,               // TabList
      ...logoList,              // LogoList
      ...otherComponents
    ];
  };

  if (loading) {
    return <Layout loading={loading} />;
  }

  return (
    <Layout
      style={{ color: "#fff" }}
      seoData={seoData}
      hamburgerStyle={{ backgroundColor: primaryColor }}
      saleClassName="btn-gradient-bdr"
      loading={loading}
      headerStyle={{ position: "relative" }}
    >
      <div className="batch-content task-initiation">
        {getReorderedComponents().map((component) => renderComponent(component))}
      </div>
    </Layout>
  );
};

export default TaskInitiation;